module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens17-3d504cdfb6f12e01890b1248c409cd1b.jpg";